import { render } from "./Customer.vue?vue&type=template&id=fafaefa6&scoped=true"
const script = {}

import _style_0 from "./Customer.vue?vue&type=style&index=0&id=fafaefa6&inline&scoped=true&lang=css"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-fafaefa6"]])

export default __exports__